import { doGetRequest } from "./../../shared/api/base-api";
import { apiUrl } from "./../../shared/constants";

//Subscription List data api
export function getSubscriptionsListData() {
  return doGetRequest(apiUrl.subscriptionsList);
}
